import { useTranslation } from "@redotech/redo-i18n";
import type { IsDeliveredState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const IsDeliveredDetails = memo(function IsDeliveredDetails({
  disabled,
}: ConditionTypeDetailsProps<IsDeliveredState>) {
  const { t } = useTranslation();
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        {t("Condition")}
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="secondary">
        {t(
          "Applies when the carrier reports the item's package as delivered or picked up. Packages with no tracking status are treated as not delivered.",
        )}
      </Text>
    </Flex>
  );
});
